/** Przydatne linki:
 * 1) https://redux.js.org/tutorials/fundamentals/part-2-concepts-data-flow#immutability
 * 2) https://immerjs.github.io/immer/
*/

import { configureStore } from '@reduxjs/toolkit'
import applicationState, { initialApplicationState } from './ApplicationSlice/ApplicationSlice'
import globalConfigurationState, { initialGlobalConfigurationState } from './GlobalConfigurationSlice/GlobalConfigurationSlice'
import hubState, { initialHubState } from './HubSlice/HubSlice'
import consentsState, { initialConsentsState } from './ConsentsSlice/ConsentsSlcie'
import { AppStorage } from '../common/AppStograge'
import { SessionStorage } from '../common/CookieStorage'
import { SLICE_KEYS } from './SliceKeys'
import formState, { initialFormState } from './FormSlice/FormSlice'
import instalmentsMonthsState, { initialInstalmentsMonthsState } from './InstalmentsMonthsSlice/InstalmentsMonthsSlice'
import contractSignState, { initialContractSignState } from './ContractSignSlice/ContractSignSlice'
import textContentsState, { initialTextContentsState } from './TextContentsSlice/TextContentsSlice'
import videoVerificationState, { initialVideoVerificationState } from './VideoVerificationSlice/VideoVerificationSlice'


export const saveCurrentState = (state : AppState) => {

  const appStorage = new AppStorage();
  const sessionStorage = new SessionStorage();
  appStorage.clearLocalStorage()
  
  if(appStorage.userHasSession()){
    const appJson = JSON.stringify(state.applicationState);
    sessionStorage.add(SLICE_KEYS.APPLICATION_SLICE, appJson);

    const consentJSON = JSON.stringify(state.consentsState);
    sessionStorage.add(SLICE_KEYS.CONSENTS_SLICE, consentJSON);

    
    const globalConfigurationState = JSON.stringify(state.globalConfigurationState)
    sessionStorage.add(SLICE_KEYS.GLOBAL_CONFIGURATION_SLICE, globalConfigurationState)

    const textContentsState = JSON.stringify(state.textContentsState)
    sessionStorage.add(SLICE_KEYS.TEXT_CONTENTS_SLICE, textContentsState)

    const formState = JSON.stringify(state.formState)
    sessionStorage.add(SLICE_KEYS.FORM_SLICE, formState)

    const instalmentsMonthsState = JSON.stringify(state.instalmentsMonthsState)
    sessionStorage.add(SLICE_KEYS.INSTALMENTS_MONTHS_SLICE, instalmentsMonthsState)

    const contractSignState = JSON.stringify(state.contractSignState)
    sessionStorage.add(SLICE_KEYS.CONTRACT_SIGN_SLICE, contractSignState)

    const videoVerificationState = JSON.stringify(state.videoVerificationState)
    sessionStorage.add(SLICE_KEYS.VIDEO_VERIFICATION_SLICE, videoVerificationState)
  }
}

const loadState = () => {
  const appStorage = new AppStorage()

  const applicationState = getSessionState(SLICE_KEYS.APPLICATION_SLICE, initialApplicationState)

  const globalConfigurationState = getSessionState(SLICE_KEYS.GLOBAL_CONFIGURATION_SLICE, initialGlobalConfigurationState)
  const textContentsState = getSessionState(SLICE_KEYS.TEXT_CONTENTS_SLICE, initialTextContentsState)
  const consentsState = getSessionState(SLICE_KEYS.CONSENTS_SLICE, initialConsentsState)
  const formState = getSessionState(SLICE_KEYS.FORM_SLICE, initialFormState)
  const instalmentsMonthsState = getSessionState(SLICE_KEYS.INSTALMENTS_MONTHS_SLICE, initialInstalmentsMonthsState)
  const contractSignState = getSessionState(SLICE_KEYS.CONTRACT_SIGN_SLICE, initialContractSignState)
  const videoVerificationState = getSessionState(SLICE_KEYS.VIDEO_VERIFICATION_SLICE, initialVideoVerificationState)
  


  return {
    applicationState,
    globalConfigurationState,
    textContentsState,
    formState,
    contractSignState,
    videoVerificationState,
    hubState: initialHubState,
    consentsState: consentsState,
    instalmentsMonthsState: instalmentsMonthsState,
  }
}

const getState = <T>(key: string, storage: AppStorage, initialState: T): T => {
  if(storage.isKeyExists(key) && storage.userHasSession()){
    const stateJson = storage.getItem(key)
    const result = JSON.parse(stateJson)
    return result as unknown as T
  }

  return initialState as T
}

const getSessionState = <T>(key: string, initialState: T) => {
  const sessionStorage = new SessionStorage()
  const stateJson = sessionStorage.get(key)
  let state = initialState

  if(stateJson != null && stateJson){
    state = JSON.parse(stateJson)
  }

  return state
}

export const store = configureStore({
  reducer: {
     applicationState,
     globalConfigurationState,
     textContentsState,
     hubState,
     consentsState,
     formState,
     instalmentsMonthsState,
     contractSignState,
     videoVerificationState
  },
  preloadedState: loadState(),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type AppState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch